module.exports = __webpack_public_path__ + "img/O-basic.6f359200.svg";